import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

import * as loginActions from 'modules/login';
import * as userActions from 'modules/user';

import * as commonVar from 'libs/commonVar';
import * as common from 'libs/commonFunc';

import { clearReduxStore } from 'containers/InitialStore';

import { Form, Input, Button, Label } from 'semantic-ui-react';
import { CtAdminFirstLogin, CtAdminChangePW } from 'containers';

import { AlreadyLoginPage } from 'pages';

import classNames from 'classnames/bind';
import styles from './CtAdminLogin.css';
const cx = classNames.bind(styles);

class CtAdminLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      alreadLogin: 0,
      isFirstLogin: false,
      isChangePw: false
    };
  }

  componentWillMount() {
    // 이미 로그인된 상태인지 확인하여 render 시 안내
    if (this.props.isAuth === 2) {
      this.setState({ alreadLogin: 1 });
    }

    // store 초기화
    const { Dispatch } = this.props;
    clearReduxStore(Dispatch, 'all');
  }

  componentDidMount() {
    this.setState({ isFirstLogin: false, isChangePw: false });
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (
      this.props.isAuth !== nextProps.isAuth ||
      this.props.loginResult !== nextProps.loginResult ||
      this.state.alreadLogin !== nextState.alreadLogin ||
      this.state.isFirstLogin !== nextState.isFirstLogin ||
      this.state.isChangePw !== nextState.isChangePw ||
      this.state.isLoading !== nextState.isLoading
    ) {
      return true;
    }
    return false;
  }

  signIn = async () => {
    const { LoginActions, UserActions, form } = this.props;
    const { userEmail, userPasswd } = form.toJS();
    const isAdmin = 1;

    if (!!this.state.isLoading) {
      return false;
    }

    try {
      this.setState({ isLoading: true });
      await LoginActions.postLogin({ userEmail: userEmail.toLowerCase(), userPasswd, isAdmin });

      const { userData, loginResult, sessionTimeout } = this.props;

      if (loginResult === 1) {
        /* -- 로그인 성공 -- */

        if (commonVar.isGs === 1) {
          sessionStorage.setItem('curUser', userData.userEmail);
        }
        localStorage.setItem('loginAdmin', userData.userEmail);
        localStorage.removeItem('loginUser');
        sessionStorage.setItem('accessTime', common.nowEpoch());

        // 유저 정보 저장
        UserActions.setUser({ user: userData, sessionTimeout });
      } else if (loginResult === 2) {
        /* -- 로그인 서버 에러 -- */
      } else if (loginResult === 4) {
        /* -- ID or 비밀번호 불일치 -- */
      } else if (loginResult === 8) {
        /* -- 비밀번호 5회 이상 실패 -- */
        // google reCAPTCHA
        // LoginActions.activeRecaptcha();
        /* -- 6개월 이상 비밀번호 미변경 -- */
      } else if (loginResult === 16) {
        this.setState({ isChangePw: true });
        //
      } else if (loginResult === 256) {
        /* -- 관리자의 최초 로그인시 아이디 비밀번호 수정 화면 -- */
        this.setState({ isFirstLogin: true });
      } else {
        //
      }

      this.setState({ isLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  // input에 값 입력 처리
  handleChange = e => {
    const { LoginActions, loginResult } = this.props;
    const { name, value } = e.target;

    LoginActions.changeInput({
      name,
      value
    });

    // 실패 메세지 지움
    if (loginResult > 1) {
      LoginActions.initLoginResult();
    }
  };

  handleKeyPress = e => {
    const { name, value } = e.target;

    if (name === 'userPasswd' && e.key.toLowerCase() === 'enter') {
      this.signIn();
    }
  };

  render() {
    if (this.state.alreadLogin) {
      // 이미 로그인 된 상태로 접속
      return <AlreadyLoginPage accessLevel={2} />;
    }

    if (this.props.isAuth === 2) {
      // 로그인 페이지에서 로그인 성공 처리된 것
      return (
        <Redirect
          to={{
            pathname: '/mudmanage'
          }}
        />
      );
    }

    const { LoginActions, loginResult, loginMessage, isCaptcha, pending } = this.props;
    const { formatMessage } = this.props.intl;
    const displayError = cx({
      'login-error': true,
      'display-none': loginResult > 1 && !!loginMessage ? false : true
    });

    // [GS인증] 로그인 실패 횟수 초과 경우 5분의 잠금
    let loginMessageText = String(loginMessage);
    if (loginResult === 8) {
      const remainTime = 300 - (common.nowEpoch().toFixed() - loginMessage.split(',')[1]);

      loginMessageText =
        loginMessage.split(',')[0] +
        ' (' +
        defineMessages(formatMessage({ id: 'CtLogin_1', defaultMessage: '남은 시간' })) +
        ': ' +
        (parseInt(remainTime / 60) > 0
          ? parseInt(remainTime / 60) + defineMessages(formatMessage({ id: 'CtLogin_2', defaultMessage: '분' })) + ' '
          : '') +
        parseInt(remainTime % 60) +
        defineMessages(formatMessage({ id: 'CtLogin_3', defaultMessage: '초' })) +
        ')';
    }

    let LoginComponent;
    // 최초 로그인시 ID/Password 변경
    if (!!this.state.isFirstLogin) {
      LoginComponent = <CtAdminFirstLogin />;
    } else if (!!this.state.isChangePw) {
      LoginComponent = <CtAdminChangePW />;
    }

    return (
      <div className={cx('admin-login')}>
        {!!LoginComponent ? (
          LoginComponent
        ) : (
          <div className={cx('admin-login-area')}>
            <Label className={cx('admin-login-title')}>
              {defineMessages(formatMessage({ id: 'CtAdminLogin_1', defaultMessage: '관리자 서비스' }))}
            </Label>
            <div className={cx('login-input')}>
              <Form autoComplete="new-password">
                <div className={cx('wrap-input')}>
                  <Form.Input
                    type="text"
                    name="userEmail"
                    className={cx('wrap-input')}
                    placeholder={'ID'}
                    onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    autoComplete="off"
                  />
                </div>
                <div className={cx('wrap-input')}>
                  <Form.Input
                    type="password"
                    name="userPasswd"
                    className={cx('wrap-input')}
                    placeholder={defineMessages(formatMessage({ id: 'CtAdminLogin_3', defaultMessage: '비밀번호' }))}
                    onChange={this.handleChange}
                    onKeyPress={this.handleKeyPress}
                    autoComplete="new-password"
                  />
                </div>
              </Form>
            </div>
            {/* 로그인 실패시 에러 메세지 */}
            <Label className={displayError}>{loginMessageText}</Label>
            {/* 로그인 버튼 */}
            <Button className={cx('bt-signIn')} loading={this.state.isLoading} onClick={this.signIn}>
              {defineMessages(formatMessage({ id: 'CtAdminLogin_4', defaultMessage: '로그인' }))}
            </Button>
          </div>
        )}
      </div>
    );
  }
}

CtAdminLogin.propTypes = {};
CtAdminLogin.defaultProps = {};

const mapStateToProps = state => ({
  login: state.login.get('login'),
  loginResult: state.login.getIn(['login', 'loginResult']),
  loginMessage: state.login.getIn(['login', 'loginMessage']),
  userData: state.login.getIn(['login', 'userData']),
  sessionTimeout: state.login.getIn(['login', 'sessionTimeout']),
  form: state.login.get('form'),
  visibleCaptcha: state.login.getIn(['visible', 'captcha']),
  //visibleModal: state.login.getIn(['visible', 'modal']),
  isAuth: state.user.get('isAuth'),
  pending: state.pender.pending['login/POST_LOGIN']
});

const mapDispatchToProps = dispatch => ({
  LoginActions: bindActionCreators(loginActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtAdminLogin));



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminLogin.js